let defaultStandardExplanationLength = 0;

$('textarea[name="explanation"]').keyup(function () {
    if (defaultStandardExplanationLength === 0) {
        toggleSubmitStateButton($(this).val().length >= 25);
    } else {
        toggleSubmitStateButton($(this).val().length >= defaultStandardExplanationLength + 10);
    }
});

$(document).find('.stateFormContainer').each(function () {
    initializeBookingStateForm($(this));
});

$(document).bind('new-booking-state-form', function (e, container) {
    initializeBookingStateForm($(container));
})

$('select[name="reason"]').change(function () {
    toggleReasonExplanation($(this));
});
toggleReasonExplanation($('select[name="reason"]'));

function toggleReasonExplanation(el)
{
    let reason = el.val();
    let container = el.parent().parent().parent();
    if (reason == 'other') {
        $('.reason_explanation', container).css('display', 'block');
    } else {
        $('.reason_explanation', container).css('display', 'none');
    }
}

function initializeBookingStateForm(stateFormContainer) {
    let state = stateFormContainer.find('.stateSelect');
    let states = stateFormContainer.find('.states');
    let stateInput = stateFormContainer.find('.newState');
    let oldState = stateFormContainer.find('input[name=old_state]').val();
    let currentState;

    state.on('click', '.dropdown-item', function (e) {
        states.show();

        states.find('input[type=checkbox]').prop('disabled', true);

        if (currentState !== undefined) {
            states.find('.' + currentState.data('state')).slideUp()
                .find('input, select, textarea')
                .prop('disabled', true).prop('required', false);
        }

        currentState = $(this);
        stateInput.val(currentState.data('state'))
        state.find('.state').removeClass(function (index, className) {
            return (className.match(/\bbadge-\S+/g) || []).join(' ');
        }).addClass(currentState.data('class')).text(currentState.text());

        states.find('.' + currentState.data('state'))
            .slideDown()
            .find('input:not([type=checkbox]):not([name=reason_explanation]), textarea, select')
            .prop('required', true);

        states.find('.' + currentState.data('state'))
            .slideDown()
            .find('input, textarea, select')
            .prop('disabled', false);

        // get container with explanation name and get value
        let explanation = states.find('.' + currentState.data('state')).find('textarea[name="explanation"]');

        // check if explanation has standard template data attribute
        if (explanation.data('standard-template') !== undefined) {
            // set Global variable defaultStandardExplanationLength
            defaultStandardExplanationLength = explanation.val().length;

            $('.btn-submit-state').removeClass('d-none');
            toggleSubmitStateButton(false);
        } else {
            // reset Global variable defaultStandardExplanationLength
            defaultStandardExplanationLength = 0;

            $('.btn-submit-state').removeClass('d-none');
            toggleSubmitStateButton($('textarea[name="explanation"]').val().length >= 25);
        }
    });

    if (oldState !== '') {
        $('[data-state=' + oldState + ']').click();
    }

    autosize($('textarea.autosize'));
    $('textarea.autosize').on('focus change', function() {
        autosize($(this));
    })
}

function toggleSubmitStateButton(isEnabled) {
    if (isEnabled) {
        $('.btn-submit-state').removeAttr('disabled');
    } else {
        $('.btn-submit-state').attr('disabled', 'disabled');
    }
}
